/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import MuteIcon from '../icons/MuteIcon';
import BasicButton from './BasicButton';

import styles from '../../styles/buttons/control-button.module.css';

const propTypes = {
    muted: PropTypes.bool,
    className: PropTypes.string,
    buttonRef: AppPropTypes.ref,
};

const defaultProps = {
    muted: false,
    className: null,
    buttonRef: null,
};

function MuteButton({ muted, className, buttonRef, ...props }) {
    return (
        <BasicButton
            ref={buttonRef}
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            {...props}
        >
            <MuteIcon muted={muted} className={styles.icon} />
        </BasicButton>
    );
}

MuteButton.propTypes = propTypes;
MuteButton.defaultProps = defaultProps;

// eslint-disable-next-line react/jsx-props-no-spreading
export default React.forwardRef((props, ref) => <MuteButton {...props} buttonRef={ref} />);
